import i18n from '@/lang'

export default [
  {
    path: '/connection/:id/phi',
    name: 'connectionPHI',
    // component: FillPatientPHI,
    component: () => import('@/pages/Connection/FillPatientPHI'),
    meta: {
      title: i18n.t('router.connection.str_1'),
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/connection/:id/template',
    name: 'connectionTemplate',
    // component: ArrangeRehabPlan,
    component: () => import('@/pages/Connection/ArrangeRehabPlan'),
    meta: {
      title: i18n.t('router.connection.str_2'),
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/connection/:id/template/:level',
    name: 'modifyLevelOfConnectionTemplate',
    // component: ModifyLevelOfConnectionTemplate,
    component: () => import('@/pages/Connection/ModifyLevelOfConnectionTemplate'),
    meta: {
      title: i18n.t('router.connection.str_3'),
      requireAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/connection.js